<script setup lang="ts">
import axios from 'axios'

import type { Partner } from '@/types/types'

const { user } = useLocalStorage()
const { t } = useI18n()

const props = defineProps<{ partner: Partner }>()
const tokens = ref([])
const loaded = ref(false)

const updateTokenRevokeStatus = async (token, isGranted) => {
  const { data } = await axios.patch(`/oauth/tokens/${token.id}`, { isRevoked: !isGranted })
  token.isRevoked = data.data.isRevoked
}

const canUpdateToken = (token) => {
  return user.value.roleTemplate.slug === 'direction' || user.value.id === token.user.id
}

onMounted(async () => {
  const { data } = await axios.get(`/oauth/tokens?partner_id=${props.partner.id}`)
  tokens.value = data.data
  loaded.value = true
})
</script>
<template>
  <ul v-if="loaded" role="list" class="flex flex-col gap-y-4 overflow-y-auto">
    <li
      v-for="token in tokens"
      :key="token.id"
      class="flex items-center justify-between gap-x-6 rounded-md border bg-muted py-5 pl-2 pr-5"
    >
      <div class="flex flex-col items-center justify-center gap-x-4 md:flex-row">
        <BaseSwitch
          v-if="canUpdateToken(token)"
          :id="token.id"
          :model-value="!token.isRevoked"
          @update:model-value="updateTokenRevokeStatus(token, $event)"
        />
        <div class="flex flex-col items-center justify-center md:items-start">
          <p class="mb-1 text-sm font-semibold text-foreground">
            {{ t('pages.marketplace.marketplacePage.account') }} {{ token.user.email }}
          </p>
          <div class="flex items-center">
            <p class="text-xs text-muted-foreground">
              {{
                !token.isRevoked
                  ? t('pages.marketplace.marketplacePage.active')
                  : t('pages.marketplace.marketplacePage.inactive')
              }}
            </p>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>
